import * as React from 'react';
import * as Btn from '../Button';
import { Styledes, Acceptable, Childable } from './types';
import { plugin } from './slots';

export interface Props extends Styledes, Acceptable, Childable {
    disabled?: boolean,
}

export default React.memo(({ children, className, accept, disabled = false }: Props) => {
    return (
        <Btn.Primary 
            onClick={accept}
            className={className}
            disabled={disabled}>
            {children}
        </Btn.Primary>
    )
});

export const acceptTooltiped = plugin('accept_tooltiped', 'accept');
